import { render } from "./HammerSvg.vue?vue&type=template&id=098b9574"
import script from "./HammerSvg.vue?vue&type=script&lang=js"
export * from "./HammerSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__